import formatarCPF from "../../../helpers/formatCPF";

function InputCpf({ cpf, setCpf, OnSubmitData }) {
  return (
    <>
      <div
        style={{
          marginTop: 25,
          flexDirection: "column",
          display: "flex",
        }}
      >
        <span
          style={{
            fontWeight: "600",
            fontSize: 16,
            color: "#191919",
          }}
        >
          Antes de continuar, qual é o seu CPF?
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <input
          style={styles.inputStyle}
          value={formatarCPF(cpf)}
          onChange={(e) => setCpf(formatarCPF(e.target.value))}
        />
        <button style={styles.buttonNext} onClick={() => OnSubmitData()}>
          Continuar
        </button>
      </div>
    </>
  );
}

const styles = {
  container: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#141414",
  },

  footer: {
    width: "80%",

    borderTopColor: "#E0E0E0",
    borderTopWidth: 1,
  },

  buttonNext: {
    backgroundColor: "#86BFC6",
    width: "70%",
    height: 43,
    borderRadius: 18,
    color: "#fff",
    border: "none",
    fontWeight: "600",
    fontSize: 14,
    cursor: "pointer",
    marginTop: 30,
  },
  inputStyle: {
    borderRadius: 18,
    padding: 16,
    marginTop: 15,
    border: "1px solid #E0E0E0",
    width: "70%",
  },
};

export default InputCpf;
